const TEST_API_URL = 'https://docmanagement.qa.parchment.com';
const PROD_API_URL = 'https://docmanagement.parchment.com';

const getApiUrl = stage => {
  if (stage === 'prod') {
    return PROD_API_URL;
  }
  return TEST_API_URL;
};

export const getDocumentContent = (token, client, documentid, stage) => {
  // call the server so we can check auth and get our cookies set
  let isPresignedUrl = false;
  console.log(
    'about to fetch ',
    `${getApiUrl(
      stage
    )}/v1/api/archive/${client}/document/${documentid}/content`
  );
  console.log('token', token);
  return fetch(
    `${getApiUrl(
      stage
    )}/v1/api/archive/${client}/document/${documentid}/content`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${token}`
      }
    }
  )
    .then(response => {
      console.log('response', response);
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      var contentType = response.headers.get('content-type');
      if (contentType === 'text/html') {
        return Promise.reject('NotAuthenticated');
      }
      console.log('contentType', contentType);
      isPresignedUrl = contentType === 'text/plain';
      return response.text();
    })
    .then(body => {
      console.log('isPre', isPresignedUrl);
      if (isPresignedUrl) {
        return fetchS3PresignedObject(body);
      } else {
        return base64ToArrayBuffer(body);
      }
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const fetchS3PresignedObject = url => {
  return fetch(url, {
    method: 'GET'
  })
    .then(response => {
      console.log('response from s3', response);
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      return response.arrayBuffer();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const loadAnnotations = (token, tenantId, documentId, stage) => {
  return fetch(
    `${getApiUrl(
      stage
    )}/v1/api/archive/${tenantId}/document/annotations/${documentId}`,
    {
      method: 'GET',
      headers: {
        Authorization: token
      }
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

export const saveAnnotations = (
  token,
  tenantId,
  documentId,
  annotationJSON,
  stage
) => {
  return fetch(
    `${getApiUrl(
      stage
    )}/v1/api/archive/${tenantId}/document/annotations/${documentId}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token
      },
      body: JSON.stringify({
        annotationJSON
      })
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

const base64ToArrayBuffer = base64 => {
  var binary = window.atob(base64);
  var bytes = new Uint8Array(binary.length);
  for (var i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};

export const authenticate = (client, isCumulativeFolder) => {
  var host = `https://${client}`;
  if (process.env.NODE_ENV === 'development') {
    host = `http://${client}`;
  }
  let initialPath = 'integration';
  if (isCumulativeFolder) {
    initialPath = 'cumulativefolder';
  }
  return fetch(`${host}/${initialPath}/viewer/auth`, {
    method: 'POST',
    credentials: 'include',
    mode: 'cors' // no-cors
  }).then(response => {
    if (response.status !== 200) {
      return Promise.reject(`Returned code ${response.status}`);
    }
    var contentType = response.headers.get('content-type');
    if (contentType === 'text/html') {
      return Promise.reject('NotAuthenticated');
    }
    // check to make sure this isnt a redirect and is a valid repsonse
    return response.text();
  });
};
